import { Link } from "react-router";
import { Alerta, Badge, BarraProgreso, Button, Card, Galeria, MetricCard, Spinner, Stack, TituloPantalla } from "@/components";
import { useNovedadesTab } from "./useNovedadesTab";

/** Inicio del fiduciante: tablero con su cuenta, el avance, los gastos y el proyecto, y las novedades. Todo se toca. */
export function NovedadesTab() {
  const t = useNovedadesTab();
  return (
    <Stack espacio={8} className="motion-safe:animate-aparecer">
      <TituloPantalla antetitulo="Tu inversión" titulo="Hola, " destacado={t.nombre} />
      {t.cartelInstalar && (
        <Card>
          <div className="flex items-start justify-between gap-3">
            <p className="text-chico">
              Instalá la app para recibir avisos en el celular.{" "}
              <Link to="/perfil" className="font-medium text-primario underline">
                Cómo instalarla
              </Link>
            </p>
            <Button variante="fantasma" aria-label="Cerrar" onClick={t.cerrarCartel}>
              ×
            </Button>
          </div>
        </Card>
      )}
      {t.errorCuenta && <p className="rounded-control bg-superficie-2 px-3 py-2">{t.errorCuenta}</p>}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {t.tarjeta && (
          <>
            {t.tarjeta.faltaAportar && <MetricCard titulo="Falta aportar" tono={t.tarjeta.faltaAportar.tono} valor={t.tarjeta.faltaAportar.valor} detalle={t.tarjeta.faltaAportar.detalle} to="/mi-cuenta" />}
            <MetricCard titulo="Estado de cuenta corriente" tono={t.tarjeta.tono} valor={t.tarjeta.valor} detalle={t.tarjeta.estado} to="/mi-cuenta" />
            <MetricCard titulo="Aportaste" valor={t.tarjeta.aportado} detalle="Hasta hoy · ver mis aportes" to="/mi-cuenta" />
          </>
        )}
        {t.tablero.map((c) => (
          <MetricCard
            key={c.ruta}
            titulo={c.titulo}
            valor={c.valor}
            detalle={c.detalle}
            to={c.ruta}
            debajoValor={c.porcentaje != null && <BarraProgreso porcentaje={c.porcentaje} tono="primario" etiqueta={c.titulo} />}
          />
        ))}
      </div>
      <Stack espacio={3}>
        <h2 className="text-titulo font-light tracking-tight">Novedades</h2>
        {t.cargandoNoticias && (
          <div className="grid place-items-center py-6 text-primario">
            <Spinner />
          </div>
        )}
        {t.errorNoticias && (
          <Stack espacio={3}>
            <Alerta texto={t.errorNoticias} />
            <div>
              <Button variante="secundario" onClick={t.reintentarNoticias}>
                Reintentar
              </Button>
            </div>
          </Stack>
        )}
        {!t.cargandoNoticias && !t.errorNoticias && t.noticias.length === 0 && <p className="text-texto-suave">Todavía no hay novedades.</p>}
        {t.noticias.length > 0 && (
          <ul aria-label="Novedades" className="flex flex-col gap-3">
            {t.noticias.map((n) => (
              <li key={n.clave}>
                <Card className={n.ruta ? "relative transition-colors hover:border-primario/40 focus-within:ring-2 focus-within:ring-primario/40" : undefined}>
                  <Stack espacio={2}>
                    <div className="flex items-center gap-2">
                      <Badge tono={n.tono}>{n.etiqueta}</Badge>
                      <span className="text-chico text-texto-suave">{n.fecha}</span>
                    </div>
                    {n.ruta ? (
                      // El link se estira sobre toda la tarjeta; la galería queda encima para abrir las fotos.
                      <span className="flex items-center justify-between gap-2 font-medium">
                        <Link to={n.ruta} className="after:absolute after:inset-0 after:rounded-tarjeta focus:outline-none">
                          {n.titulo}
                        </Link>
                        <span aria-hidden="true" className="text-primario">›</span>
                      </span>
                    ) : (
                      <span className="font-medium">{n.titulo}</span>
                    )}
                    {n.texto && <p className="whitespace-pre-line text-chico text-texto-suave">{n.texto}</p>}
                    {n.fotos.length > 0 && (
                      <div className="relative z-10">
                        <Galeria etiqueta={`Fotos de ${n.titulo}`} fotos={n.fotos} />
                      </div>
                    )}
                  </Stack>
                </Card>
              </li>
            ))}
          </ul>
        )}
        {t.hayMas && (
          <div>
            <Button variante="secundario" onClick={t.verMas} cargando={t.cargandoMas}>
              Ver más
            </Button>
          </div>
        )}
      </Stack>
    </Stack>
  );
}
